// @core/api/endpoints/notifications/validate_channel_config.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ValidateChannelConfigRequest,
  ValidateChannelConfigResponse,
} from '../../../types/notifications';

const BASE_PATH = '/notifications';

/**
 * Validate channel configuration
 * Validates a channel configuration without saving it. Checks for required fields, valid credentials, and provider connectivity.
 */
export async function ValidateChannelConfig(
  data: ValidateChannelConfigRequest,
  options?: RequestOptions
): Promise<ValidateChannelConfigResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/channels/validate-config`;
  const requestOptions = options;
  return client.post<ValidateChannelConfigResponse>(requestPath, data, requestOptions);
}
